import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppService } from 'src/app/services/core/app.service';

@Component({
  selector: 'app-main-item',
  templateUrl: './main-item.component.html',
  styleUrls: ['./main-item.component.css'],
})
export class MainItemComponent implements OnInit {
  mode$: BehaviorSubject<'concert' | 'concert-grouped' | 'ticket'> =
    new BehaviorSubject(null);
  constructor(public appService: AppService) {}

  ngOnInit() {
    this.appService.settings$.subscribe((settings) => {
      if (!settings) return;
      if (settings.ISACTIVECONCERTGROUPED) {
        this.mode$.next('concert-grouped');
      } else if (settings.CONCERTSALEACTIVE) {
        this.mode$.next('concert');
      } else if (settings.ENTRANCETICKETACTIVE) {
        this.mode$.next('ticket');
      } else {
        this.mode$.next('concert');
      }
    });
  }
}
